document.addEventListener('DOMContentLoaded', function () {
  function updateMetalTitle() {
    const activeRow = document.querySelector('.variant_metal-row.active');
    const titleSpan = document.querySelector('.variant_picker-metal .variant-title-shap span');

    if (activeRow && titleSpan) {
      const metalName = activeRow.querySelector('p')?.textContent.trim();

      if (metalName) {
        titleSpan.textContent = metalName;
        console.log('Metal:', metalName);
      }
    }
  }
  updateMetalTitle();
  const observer = new MutationObserver(function () {
    updateMetalTitle();
  });

  document.querySelectorAll('.variant_metal-row').forEach(row => {
    observer.observe(row, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  const activeMetal = document.querySelector('.variant_metal-row.active p');
  const metalTitle = document.querySelector('.variant_picker-metal .variant-title-shap span');
  if (activeMetal && metalTitle) {
    metalTitle.textContent = activeMetal.textContent.trim();
  }
  const activeShape = document.querySelector('.variant_dShap-row.active p');
  const shapeTitle = document.querySelector('.variant_picker-dShap .variant-title-shap span');
  if (activeShape && shapeTitle) {
    shapeTitle.textContent = activeShape.textContent.trim();
  }

  function updateVariantTitles() {
    const activeMetal = document.querySelector('.variant_metal-row.active p');
    const metalTitle = document.querySelector('.variant_picker-metal .variant-title-shap span');
    if (activeMetal && metalTitle) {
      metalTitle.textContent = activeMetal.textContent.trim();
    }
    const activeShape = document.querySelector('.variant_dShap-row.active p');
    const shapeTitle = document.querySelector('.variant_picker-dShap .variant-title-shap span');
    if (activeShape && shapeTitle) {
      shapeTitle.textContent = activeShape.textContent.trim();
    }
    const activeStone = document.querySelector('.variant_stone-row.active p');
    const stoneTitle = document.querySelector('.variant_picker-stone .variant-title-shap span');
    if (activeStone && stoneTitle) {
      stoneTitle.textContent = activeStone.textContent.trim();
    }
  }

  updateVariantTitles();
});
